import * as React from 'react';
import { useState, useEffect } from "react";
import Modal from "../../../component/Global/Modal";
import { useQuoteStore } from "../../../hooks/quote";
import { useQuoteFilterSelectionStore } from 'src/hooks/component/quote-filter-selection';
import { DateRangePicker } from 'rsuite';
import moment from 'moment'
import Common from '../Common';
import Helper from 'src/support/Helper';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';

// DT - 8419 - 30Feb23 - when PendingStatus is selected other are disabled & when other is selected Pending is Disabled

const QuoteAdvanceFilterPopup = (props) => {
    const [status, SetStatus] = useState(false);
    const [{ QuoteAdvanceFilterPopup }, { }, { }] = useDOMAttachToSystemStore();
    const [{ quoteReasonList, statusList }, { get_quote_reason_list }, { }] = useQuoteStore();
    const defaulDateRange = [null, null];
    const [dateRangeObject, set_dateRangeObject] = useState(defaulDateRange);
    const [expDateRangeObject, set_exp_dateRangeObject] = useState(defaulDateRange);
    const [{ filter_list }, { }, { set_filter_list }] = useQuoteFilterSelectionStore();
    const filterDetail = { quoteNumber: '', manufacturerPartNumber: '', customerPartNumber: "", quoteReasonType: "", manufacturer: "", buyer: "" };
    const [formData, setFormData] = useState(filterDetail)
    const [validationDetail, setValidationDetail] = useState({});
    const charMsg = "Please enter at least 3 characters to execute a keyword search.";

    const searchList = [
        { searchKey: "quoteNumber", searchType: "Quote Number", searchKeyword: "" },
        { searchKey: "manufacturerPartNumber", searchType: "Manufacturer Part Number", searchKeyword: "" },
        { searchKey: "customerPartNumber", searchType: "Customer Part Number", searchKeyword: "" },
        { searchKey: "quoteReasonType", searchType: "Quote Reason", searchKeyword: "" },
        { searchKey: "manufacturer", searchType: "Manufacturer", searchKeyword: "" },
        { searchKey: "submissionDate", searchType: "Submission Date", searchKeyword: "" },
        { searchKey: "expirationDate", searchType: "Expiration Date", searchKeyword: "" },
        { searchKey: "status", searchType: "Quote Status", searchKeywordArr: [] },
        { searchKey: "buyer", searchType: "Buyer", searchKeyword: "" }
    ]

    useEffect(() => {
        // 11360
        async function fetchHere() {
            await get_quote_reason_list();
        }
        if (quoteReasonList && quoteReasonList?.length === 0)
            fetchHere();
    }, []);

    useEffect(() => {
        if (filter_list?.length > 0) {
            let filterData = filterDetail;
            Object.keys(filter_list).forEach((property) => {
                if (filter_list[property].searchKey === 'status') {
                    filter_list[property].searchKeywordArr.forEach(ele => {
                        let statusId = Object.values(statusList).find(f => f.text === ele).id;
                        filterData[statusId] = statusId;
                    });
                } else if (filter_list[property].searchKey === 'submissionDate') {
                    set_dateRangeObject(setInitialDateVal(filter_list[property].searchKeyword))
                } else if (filter_list[property].searchKey === 'expirationDate') {
                    set_exp_dateRangeObject(setInitialDateVal(filter_list[property].searchKeyword))
                } else {
                    filterData[filter_list[property].searchKey] = filter_list[property].searchKeyword;
                }
            });
        }
    }, []);


    const setInitialDateVal = (dtObj) => {
        let _dt = dtObj.split("-");
        _dt[0] = new Date(_dt[0]);
        _dt[1] = new Date(_dt[1]);
        return _dt;
    }

    useEffect(() => {
        if (QuoteAdvanceFilterPopup) {
            SetStatus(true)
        }
    }, [QuoteAdvanceFilterPopup]);

    const onHide = (action = true) => {
        SetStatus(false)
    };

    const onValueChange = (field, value) => {
        setFormData({ ...formData, [field]: value })
        validateOnChange(field, value);
    }

    const onSelectStatus = (e) => {
        const val = e.target.value;
        if (e.target.checked) {
            setFormData({ ...formData, [val]: val })
        } else {
            let data = { ...formData };
            delete data[val];
            setFormData(data);
        }
    }

    const validateOnChange = (field, value) => {
        if (field === 'buyer' || field === 'customerPartNumber' || field === 'manufacturer' || field === 'manufacturerPartNumber' || field === 'quoteNumber') {
            if (value) {
                const isValid = Common.validateMinCharacter(value);
                if (isValid) {
                    let validateData = { ...validationDetail };
                    delete validateData[field];
                    setValidationDetail(validateData)
                }
            } else {
                let validateData = { ...validationDetail };
                delete validateData[field];
                setValidationDetail(validateData)
            }
        }
    }

    const onApplyFilter = () => {
        let data = formData;
        const isValid = checkValidation(data);
        if (isValid) {
            let orderSearch = [];
            let statusListSel = [];
            if (JSON.stringify(dateRangeObject) !== JSON.stringify(defaulDateRange))
                data.submissionDate = setDateForFilter(dateRangeObject);
            if (JSON.stringify(expDateRangeObject) !== JSON.stringify(defaulDateRange))
                data.expirationDate = setDateForFilter(expDateRangeObject);

            Object.keys(data).forEach((property) => {
                if (data[property].trim()) {
                    let searchObj = searchList.find(f => f.searchKey === property)
                    if (searchObj) {
                        searchObj.searchKeyword = data[property].trim();
                        orderSearch.push(searchObj);
                    } else {
                        statusListSel.push(statusList[data[property]].text)
                    }
                }
            });

            if (statusListSel.length > 0) {
                let searchObj = searchList.find(f => f.searchKey === "status")
                searchObj.searchKeywordArr = statusListSel
                orderSearch.push(searchObj);
            }
            set_filter_list(orderSearch)
            onHide();
        }
    }

    useEffect(() => {
        if (dateRangeObject[0] !== null)
            setDateForFilter(dateRangeObject);
    }, [dateRangeObject])

    useEffect(() => {
        if (expDateRangeObject[0] !== null)
            setDateForFilter(expDateRangeObject);
    }, [expDateRangeObject])

    const setDateForFilter = (dtObj) => {
        let dt1_frm = moment(dtObj[0]).local().format(Helper.getDatepickerFormat().toUpperCase());
        let dt2_frm = moment(dtObj[1]).local().format(Helper.getDatepickerFormat().toUpperCase());
        let _dt = dt1_frm + ' - ' + dt2_frm;
        return _dt;
    }

    const checkValidation = (data) => {
        let validateData = {};
        Object.keys(data).forEach((property) => {
            if (property === 'buyer' || property === 'customerPartNumber' || property === 'manufacturer' || property === 'manufacturerPartNumber' || property === 'quoteNumber') {
                if (data[property]) {
                    const isValid = Common.validateMinCharacter(data[property]);
                    if (isValid === false) {
                        validateData[property] = charMsg;
                    } else {
                        delete validateData[property];
                    }
                } else {
                    delete validateData[property];
                }
            }
        });

        setValidationDetail(validateData)
        return Object.keys(validateData).length > 0 ? false : true;
    }

    const onSetDateRange = (e) => {
        if (e) {
            set_dateRangeObject(e)
        } else {
            set_dateRangeObject(defaulDateRange)
        }
    }
    const onSetExpDateRange = (e) => {
        if (e) {
            set_exp_dateRangeObject(e)
        } else {
            set_exp_dateRangeObject(defaulDateRange)
        }
    }
    const isPendingStatus = (status) => {
        let isDisabled = false;
        if (status === 'P') {
            isDisabled = (formData?.A === "A" || formData?.B === "B" || formData?.E === "E" || formData?.R === "R") ? true : false;
        } else {
            isDisabled = (formData?.P === "P") ? true : false;
        }
        return isDisabled;
    }

    return (
        <>
            <Modal show={status} onHide={() => { onHide() }}>
                <div className=" avnet-modal modal-550">
                    <div className="avnet-modal-inner">
                        <button type="button" className="close py-3" data-dismiss="modal"
                            onClick={() => { onHide() }}>×</button>
                        <div className="modal-header">
                            <h4 className="modal-title text-center">Filter Quotes</h4>
                        </div>
                        <form id="hook-form">
                            <div className="modal-body">
                                <div className="popup-subheader">FILTER BY DATES</div>
                                <div className="row bs5">
                                    <div className="form-group col-6">
                                        <label htmlFor="usr">Quote Submission Date:</label>
                                        <DateRangePicker
                                            style={{ width: '100% !important' }}
                                            placeholder="Date Range"
                                            onChange={(dates, event) => {
                                                onSetDateRange(dates);
                                            }}
                                            value={dateRangeObject}
                                            ranges={[]}
                                            character=" - "
                                            cleanable={false}
                                            format={Helper.getDatepickerFormat()}
                                            editable={false}
                                            className="w-100 datepickerinputdisable"
                                        />
                                    </div>
                                    <div className="form-group col-6">
                                        <label htmlFor="usr">Quote Expiration Date:</label>
                                        <DateRangePicker
                                            style={{ width: '100% !important' }}
                                            placeholder="Date Range"
                                            onChange={(dates, event) => {
                                                onSetExpDateRange(dates);
                                            }}
                                            value={expDateRangeObject}
                                            ranges={[]}
                                            character=" - "
                                            cleanable={false}
                                            format={Helper.getDatepickerFormat()}
                                            editable={false}
                                            className="w-100 datepickerinputdisable"
                                        />
                                    </div>
                                </div>
                                <div className="filter-by-status mb-4">
                                    <div className="popup-subheader">FILTER BY STATUS</div>
                                    <div className="filter-by-status-checkboxes">
                                        {statusList && Object.keys(statusList).map((v) => (
                                            <section className="form-check form-check-inline sm-custom_checkbox" key={v} >
                                                <input type="checkbox" className="form-check-input" disabled={isPendingStatus(v)} id={v} name={v} value={v} onChange={onSelectStatus} checked={formData[v] ? true : false} />
                                                <label className="form-check-label mt-0" id={statusList[v].id}>{statusList[v].text}</label>
                                            </section>
                                        ))}
                                    </div>
                                </div>

                                <div className="row bs5">
                                    <div className="form-group col-6">
                                        <label htmlFor="usr">Manufacturer:</label>
                                        <input type="text" className="form-control" id="manufacturer" placeholder="Manufacturer" value={formData.manufacturer} onChange={({ target: { value } }) => onValueChange('manufacturer', value)} />
                                        {validationDetail.manufacturer && <span className="required-alert">{validationDetail.manufacturer}</span>}
                                    </div>
                                    <div className="form-group col-6">
                                        <label htmlFor="usr">Manufacturer Part Number:</label>
                                        <input type="text" className="form-control" id="manufacturerPartNumber" placeholder="Manufacturer Part Number"
                                            value={formData.manufacturerPartNumber} onChange={({ target: { value } }) => onValueChange('manufacturerPartNumber', value)} />
                                        {validationDetail.manufacturerPartNumber && <span className="required-alert">{validationDetail.manufacturerPartNumber}</span>}
                                    </div>
                                    <div className="form-group col-6">
                                        <label htmlFor="usr">Quote Number:</label>
                                        <input type="text" className="form-control" id="quoteNumber" placeholder="Quote Number"
                                            value={formData.quoteNumber} onChange={({ target: { value } }) => onValueChange('quoteNumber', value)} />
                                        {validationDetail.quoteNumber && <span className="required-alert">{validationDetail.quoteNumber}</span>}
                                    </div>
                                    <div className="form-group col-6">
                                        <label htmlFor="usr">Customer Part Number:</label>
                                        <input type="text" className="form-control" id="customerPartNumber" placeholder="Customer Part Number"
                                            value={formData.customerPartNumber} onChange={({ target: { value } }) => onValueChange('customerPartNumber', value)}
                                        />
                                        {validationDetail.customerPartNumber && <span className="required-alert">{validationDetail.customerPartNumber}</span>}
                                    </div>
                                    <div className="form-group col-6">
                                        <label htmlFor="usr">Buyer:</label>
                                        <input type="text" className="form-control" id="buyer" placeholder="Buyer"
                                            value={formData.buyer} onChange={({ target: { value } }) => onValueChange('buyer', value)} />
                                        {validationDetail.buyer && <span className="required-alert">{validationDetail.buyer}</span>}

                                    </div><div className="form-group col-6">
                                        <label htmlFor="usr">Quote Reason:</label>
                                        <select className="form-control" id="quoteReasonType" value={formData.quoteReasonType} onChange={({ target: { value } }) => onValueChange('quoteReasonType', value)} >
                                            <option value="">Select a Quote Reason</option>
                                            {quoteReasonList && quoteReasonList.map((v, i) => (
                                                <option key={v.quoteReasonType} value={v.quoteReasonName}>{v.quoteReasonName}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer text-center">
                                <button type="button" className="bs5 btn btn-secondary w145" data-dismiss="modal"
                                    onClick={() => { onHide() }}>Close</button>
                                <button type="button" className="bs5 btn btn-primary w145" onClick={onApplyFilter}>Apply filters</button>
                            </div>
                        </form>
                    </div>
                </div>
            </Modal>
        </>
    )
}

export default QuoteAdvanceFilterPopup;